// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.departure-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
    padding: 20px;
    background: #f8fbff;
    border-radius: 8px;
}

.form-heading {
    margin: 20px;
    font-size: 24px;
    font-weight: 600;
    color: #222;
}

.form-field {
    display: flex;
    flex-direction: column;
    position: relative;
}

    .form-field label {
        font-weight: 500;
        margin-bottom: 6px;
    }

.flag-select-wrapper {
    display: flex;
    align-items: center;
    position: relative;
}

    .flag-select-wrapper select {
        width: 100%;
        padding-right: 36px;
    }

.dropdown-flag {
    position: absolute;
    right: 8px;
    height: 20px;
    width: 24px;
    object-fit: contain;
    pointer-events: none;
}

.form-button-wrapper {
    grid-column: 1 / -1;
    display: flex;
    justify-content: flex-end;
}

.submit-btn {
    background-color: #0047ab;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
}

    .submit-btn:hover {
        background-color: #003b91;
    }

.error-text {
    color: red;
    font-size: 12px;
    margin-top: 4px;
}
.dropdown-results {
    position: absolute;
    background: white;
    border: 1px solid #ccc;
    max-height: 240px;
    overflow-y: auto;
    z-index: 999;
    width: 100%;
    padding: 0;
    margin: 4px 0 0 0;
    list-style: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

    .dropdown-results li {
        display: flex;
        align-items: center;
        padding: 8px 10px;
        cursor: pointer;
        font-size: 14px;
        white-space: nowrap;
    }

        .dropdown-results li:hover {
            background-color: #f0f0f0;
        }

.flag-icon {
    height: 18px;
    width: 24px;
    object-fit: cover;
    margin-right: 8px;
}
.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 20px;
}

.vessel-row .form-group {
    flex: 1 1 30%;
    min-width: 180px;
}

    .vessel-row .form-group.wide {
        flex: 2 1 40%;
        min-width: 260px;
    }

.form-group input {
    width: 100%;
    padding: 8px;
    font-size: 14px;
}

.dropdown-results {
    position: absolute;
    z-index: 999;
    background: white;
    border: 1px solid #ccc;
    width: 100%;
    max-height: 240px;
    overflow-y: auto;
    margin-top: 2px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    list-style: none;
    padding: 0;
}

    .dropdown-results li {
        padding: 8px 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
    }

        .dropdown-results li:hover {
            background-color: #f0f0f0;
        }

.flag-icon {
    width: 20px;
    height: 16px;
    object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/Departure/DepartureWizard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;IAEI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;AAEJ;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;IAEI;QACI,WAAW;QACX,mBAAmB;IACvB;;AAEJ;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ;IACI,UAAU;IACV,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;AAC7C;;IAEI;QACI,aAAa;QACb,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;QACf,eAAe;QACf,mBAAmB;IACvB;;QAEI;YACI,yBAAyB;QAC7B;;AAER;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;IAEI;QACI,aAAa;QACb,gBAAgB;IACpB;;AAEJ;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,UAAU;AACd;;IAEI;QACI,iBAAiB;QACjB,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,eAAe;IACnB;;QAEI;YACI,yBAAyB;QAC7B;;AAER;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".departure-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 20px;\n    padding: 20px;\n    background: #f8fbff;\n    border-radius: 8px;\n}\n\n.form-heading {\n    margin: 20px;\n    font-size: 24px;\n    font-weight: 600;\n    color: #222;\n}\n\n.form-field {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n    .form-field label {\n        font-weight: 500;\n        margin-bottom: 6px;\n    }\n\n.flag-select-wrapper {\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\n    .flag-select-wrapper select {\n        width: 100%;\n        padding-right: 36px;\n    }\n\n.dropdown-flag {\n    position: absolute;\n    right: 8px;\n    height: 20px;\n    width: 24px;\n    object-fit: contain;\n    pointer-events: none;\n}\n\n.form-button-wrapper {\n    grid-column: 1 / -1;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.submit-btn {\n    background-color: #0047ab;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 6px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n    .submit-btn:hover {\n        background-color: #003b91;\n    }\n\n.error-text {\n    color: red;\n    font-size: 12px;\n    margin-top: 4px;\n}\n.dropdown-results {\n    position: absolute;\n    background: white;\n    border: 1px solid #ccc;\n    max-height: 240px;\n    overflow-y: auto;\n    z-index: 999;\n    width: 100%;\n    padding: 0;\n    margin: 4px 0 0 0;\n    list-style: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n    .dropdown-results li {\n        display: flex;\n        align-items: center;\n        padding: 8px 10px;\n        cursor: pointer;\n        font-size: 14px;\n        white-space: nowrap;\n    }\n\n        .dropdown-results li:hover {\n            background-color: #f0f0f0;\n        }\n\n.flag-icon {\n    height: 18px;\n    width: 24px;\n    object-fit: cover;\n    margin-right: 8px;\n}\n.form-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.vessel-row .form-group {\n    flex: 1 1 30%;\n    min-width: 180px;\n}\n\n    .vessel-row .form-group.wide {\n        flex: 2 1 40%;\n        min-width: 260px;\n    }\n\n.form-group input {\n    width: 100%;\n    padding: 8px;\n    font-size: 14px;\n}\n\n.dropdown-results {\n    position: absolute;\n    z-index: 999;\n    background: white;\n    border: 1px solid #ccc;\n    width: 100%;\n    max-height: 240px;\n    overflow-y: auto;\n    margin-top: 2px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n    list-style: none;\n    padding: 0;\n}\n\n    .dropdown-results li {\n        padding: 8px 10px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 14px;\n    }\n\n        .dropdown-results li:hover {\n            background-color: #f0f0f0;\n        }\n\n.flag-icon {\n    width: 20px;\n    height: 16px;\n    object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
